import axios from "axios";

export default {
    state: () => ({
        systemSettingList : null
    }),
    mutations: {
        setSystemSettingList:function (state,systemSettingList){
            state.systemSettingList = systemSettingList;
        },
    },
    getters: {
        getSystemSettingList : state => {
            return state.systemSettingList
        },
    },
    actions:{
        loadSystemSettingList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/system-setting", {headers})
                .then((response) => {
                    context.commit("setSystemSettingList", response.data)
                    return response.data;
                })
        },
        updateSystemSetting(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.put(context.getters.getServiceUrl + "/admin-api/system-setting", request,{headers})
                .then((response) => {
                    return response.data;
                })

        },
        createSystemSetting(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.post(context.getters.getServiceUrl + "/admin-api/system-setting", request,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        deleteSystemSetting(context,request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.delete(context.getters.getServiceUrl + "/admin-api/system-setting/"+request.id,{headers})
                .then((response) => {
                    return response.data;
                })
        },
    }
}